import { create } from 'zustand';

import { createRunErrorSlice, type RunErrorEntry, type RunErrorSlice } from './slices/createRunErrorSlice';

export type RunErrorState = RunErrorSlice;

export const useRunErrorStore = create<RunErrorState>()((...args) => ({
  ...createRunErrorSlice()(...args),
}));

/** Returns the run error for a given thread, or null. */
export const useRunErrorForThread = (threadId: string | null): RunErrorEntry | null => {
  return useRunErrorStore((state) => (threadId ? (state.byThread[threadId] ?? null) : null));
};
